import styled from 'styled-components';

const CleaningESG = styled.div`
  .row {
    font-family: 'Open Sans', sans-serif;
    display: flex;
    justify-content: center;
    background-color: #f5f5f5;
    width: 100%;
    height: 700px;
    gap: 30px;
    padding: 30px;
    margin-top: 120px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column-reverse;
      justify-content: flex-start;
      background-color: transparent;
      height: 1100px;
      padding: 0;
    }

    .col_1 {
      width: 50%;
      overflow: hidden;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        height: 250px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 20px;
      }
    }
    .col_2 {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 20px;
      line-height: 1.9;
      font-size: 1rem;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        padding: 0;
        justify-content: center;
      }

      h2 {
        opacity: 0.7;
        font-weight: 500;
        font-size: 2.3rem;
      }

      ul {
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 20px;

        li {
          list-style: none;
          border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);
          padding-bottom: 10px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 20px;

          i {
            font-size: 30px;
            color: ${(props) => props.theme.color.lightBlue};

            @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
`;
const WhyIntegrated = styled.div`
  .row {
    font-family: 'Open Sans', sans-serif;
    display: flex;
    justify-content: center;
    background-color: #f5f5f5;
    width: 100%;
    height: 800px;
    gap: 30px;
    padding: 30px;
    margin-top: 90px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column-reverse;
      justify-content: flex-start;
      background-color: transparent;
      height: 1300px;
      padding: 0;
    }

    .col_1 {
      width: 50%;
      overflow: hidden;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        height: 250px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 20px;
      }
    }
    .col_2 {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: 20px;
      line-height: 1.9;
      font-size: 1rem;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        padding: 0;
        justify-content: center;
      }

      h1 {
        font-family: 'Poppins', sans-serif;
        font-weight: 600;
        font-size: 2.3rem;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          text-align: center;
          font-size: 2rem;
        }
      }
      h1 + p {
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          text-align: center;
        }
      }

      ul {
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 20px;

        li {
          list-style: none;
          border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);
          padding-bottom: 10px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 20px;
          
          p span{
          font-weight: bold;
          }

          i {
            font-size: 30px;
            color: ${(props) => props.theme.color.lightBlue};

            @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
`;

export { CleaningESG, WhyIntegrated };
